import axios from 'axios'
import { ActionTree } from 'vuex'
import { Response } from '../response'
import { ApiVersion, RootState } from '../types'
import { NotificationsMutations } from './mutations'
import { NotificationItem, Notifications, NotificationsState } from './types'

export const actions: ActionTree<NotificationsState, RootState> = {
  //Get notification´s info
  async getNotifications({ commit }) {
    commit(NotificationsMutations.SET_LOADER, true)
    try {
      const { data } = await axios.get(`${ApiVersion.V2}/Notifications`)
      const response: Response<Array<NotificationItem>> = data
      let payload = {
        id: 5,
        value:
          response?.data?.filter((x: { readed: boolean }) => x.readed == false)
            ?.length ?? 0
      }
      let today = new Date().getUTCDate()
      let notificationsToday = response?.data?.filter((x: NotificationItem) => {
        let sendDate = new Date(x.sendDate).getDate()
        return sendDate == today
      })
      let notificationsPrevious = response?.data?.filter(
        (x: NotificationItem) => {
          let sendDate = new Date(x.sendDate).getDate()
          return sendDate != today
        }
      )

      let request: Notifications = {
        notificationsPrevious: notificationsPrevious ?? [],
        notificationsToday: notificationsToday ?? []
      }

      await commit(NotificationsMutations.SET_NOTIFICATIONS, request)
      commit('navigation/SET_ALERT_SIDEBAR', payload, { root: true })

      commit(NotificationsMutations.SET_LOADER, false)
      //dispatch('navigation/setAlertSidebar', payload, { root: true })
    } catch (error) {
      console.error(error)
    } finally {
      //commit(NotificationsMutations.SET_LOADER, false)
    }
  },

  //Patch read notification
  async patchReadNotifications({ commit, dispatch }, identifier: string) {
    commit(NotificationsMutations.SET_LOADER, true)
    try {
      await axios.patch(
        `${ApiVersion.V2}/Notifications/${identifier}/read/true`
      )
      dispatch('getNotifications')
      commit(NotificationsMutations.SET_LOADER, false)
    } catch (error) {
      console.error(error)
    } finally {
      commit(NotificationsMutations.SET_LOADER, false)
    }
  },

  async deleteNotifications({ commit, dispatch }, identifier: string) {
    commit(NotificationsMutations.SET_LOADER, true)
    try {
      await axios.delete(`${ApiVersion.V2}/Notifications/${identifier}/delete`)
      dispatch('getNotifications')
      commit(NotificationsMutations.SET_LOADER, false)
    } catch (error) {
      console.error(error)
    } finally {
      commit(NotificationsMutations.SET_LOADER, false)
    }
  }
}
